import { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useAuth } from '../../context/AuthContext';
import type { AuthContextType } from '../../types/auth';

const Mixpanel = () => {
  const { user } = useAuth() as AuthContextType;
  const envTier = import.meta.env.VITE_ENV_TIER as string;
  const token = import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN as string;

  useEffect(() => {
    // Skip all Mixpanel operations in development
    if (envTier === 'dev') {
      return;
    }
    
    // Initialize Mixpanel only once
    mixpanel.init(token, {
      debug: envTier === 'test',
      track_pageview: true,
      persistence: "localStorage",
    });
  }, []); // Empty deps array ensures this runs exactly once

  // Handle user identification separately
  useEffect(() => {
    if (envTier === 'dev' || !user?.id) {
      return;
    }
    mixpanel.identify(user.id);
  }, [user]); // Only depends on user changes

  return null;
};

export default Mixpanel;